// Collection Header V2 — Media carousel, Quicklinks carousel, Countdown timer

// ── Media Carousel ──────────────────────────────────────────────────────────

class Ch2Carousel {
  constructor(wrapper) {
    this.carousel = wrapper.querySelector('[data-ch2-carousel]');
    if (!this.carousel) return;

    this.items = Array.from(this.carousel.querySelectorAll('.ch2-carousel__item'));
    if (this.items.length === 0) return;

    this.prevBtn  = wrapper.querySelector('.ch2-carousel__btn--prev');
    this.nextBtn  = wrapper.querySelector('.ch2-carousel__btn--next');
    this.dotsWrap = wrapper.querySelector('[data-ch2-dots]');
    this.dots     = this.dotsWrap ? Array.from(this.dotsWrap.querySelectorAll('.ch2-carousel__dot')) : [];
    this.current  = 0;

    this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.current + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
  }

  go(index) {
    const len = this.items.length;
    this.current = ((index % len) + len) % len; // loop
    this.items.forEach((item, i) => item.classList.toggle('active', i === this.current));
    this.dots.forEach((dot, i) => dot.classList.toggle('active', i === this.current));
  }
}

// ── Quicklinks Carousel ─────────────────────────────────────────────────────

class Ch2QuicklinksCarousel {
  constructor(el) {
    this.track   = el.querySelector('[data-ch2-ql-track]');
    this.prevBtn = el.querySelector('.ch2-ql__arrow--prev');
    this.nextBtn = el.querySelector('.ch2-ql__arrow--next');
    if (!this.track) return;

    this.prevBtn && this.prevBtn.addEventListener('click', () => this.prev());
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.next());

    this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
    window.addEventListener('resize', () => this.updateArrows());
    this.updateArrows();
  }

  scrollStep() {
    const firstItem = this.track.querySelector('.ch2-ql__link');
    if (!firstItem) return 200;
    return firstItem.offsetWidth + parseInt(getComputedStyle(this.track).gap || '0', 10);
  }

  updateArrows() {
    if (!this.prevBtn || !this.nextBtn) return;
    const max = this.track.scrollWidth - this.track.clientWidth;
    const fitsAll = max <= 1;

    this.prevBtn.classList.toggle('ch2-ql__arrow--hidden', fitsAll);
    this.nextBtn.classList.toggle('ch2-ql__arrow--hidden', fitsAll);
    this.prevBtn.classList.toggle('ch2-ql__arrow--disabled', !fitsAll && this.track.scrollLeft <= 4);
    this.nextBtn.classList.toggle('ch2-ql__arrow--disabled', !fitsAll && this.track.scrollLeft >= max - 4);
  }

  next() {
    this.track.scrollBy({ left: this.scrollStep(), behavior: 'smooth' });
  }

  prev() {
    this.track.scrollBy({ left: -this.scrollStep(), behavior: 'smooth' });
  }
}

// ── Countdown Timer ──────────────────────────────────────────────────────────

class Ch2Countdown {
  constructor(el) {
    const raw = el.dataset.ch2Countdown;
    if (!raw) return;

    this.end      = new Date(raw).getTime();
    this.daysEl   = el.querySelector('[data-ch2-days]');
    this.hoursEl  = el.querySelector('[data-ch2-hours]');
    this.minsEl   = el.querySelector('[data-ch2-minutes]');
    this.secsEl   = el.querySelector('[data-ch2-seconds]');

    if (isNaN(this.end)) return;
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  pad(n) {
    return String(n).padStart(2, '0');
  }

  tick() {
    const diff = this.end - Date.now();
    if (diff <= 0) {
      clearInterval(this.interval);
      [this.daysEl, this.hoursEl, this.minsEl, this.secsEl].forEach(el => { if (el) el.textContent = '00'; });
      return;
    }
    const days  = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const mins  = Math.floor((diff % 3600000) / 60000);
    const secs  = Math.floor((diff % 60000) / 1000);
    if (this.daysEl)  this.daysEl.textContent  = this.pad(days);
    if (this.hoursEl) this.hoursEl.textContent = this.pad(hours);
    if (this.minsEl)  this.minsEl.textContent  = this.pad(mins);
    if (this.secsEl)  this.secsEl.textContent  = this.pad(secs);
  }
}

// ── Init ─────────────────────────────────────────────────────────────────────

function initCollectionHeaderV2() {
  document.querySelectorAll('.collection-header-v2 .ch2-right').forEach(wrapper => {
    new Ch2Carousel(wrapper);
  });

  document.querySelectorAll('[data-ch2-quicklinks]').forEach(el => {
    new Ch2QuicklinksCarousel(el);
  });

  document.querySelectorAll('[data-ch2-countdown]').forEach(el => {
    new Ch2Countdown(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionHeaderV2);
} else {
  initCollectionHeaderV2();
}
